module.exports = __webpack_public_path__ + "img/installmentBatchTypes.f6dbf487.svg";